import { render, staticRenderFns } from "./AlipayWithhold.vue?vue&type=template&id=93b25560&scoped=true"
import script from "./AlipayWithhold.vue?vue&type=script&lang=js"
export * from "./AlipayWithhold.vue?vue&type=script&lang=js"
import style0 from "./AlipayWithhold.vue?vue&type=style&index=0&id=93b25560&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b25560",
  null
  
)

export default component.exports